module.exports = __webpack_public_path__ + "static/media/close-x.f0dfa2ea.svg";